var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useState } from "react";
import { Col, Form, Row, Icon, Well } from "@brushfire/ui";
import Constants from "../../../data/constants";
import Skeleton from "@material-ui/lab/Skeleton";
import WidgetSticky from "../../Helpers/WidgetSticky";
import { useIntl } from "react-intl";
import WidgetFieldset from "../../Helpers/WidgetFieldset";
import FormikContextListener from "../../Helpers/FormikContextListener";
import { convertToFieldViews, getDefaultCountry, getDynamicFieldValidation, getInitialFieldValues, getRemoteFetchValues, getRemoteValidateRes, handleErrors, isVisible, } from "../../../data/helpers";
import * as Yup from "yup";
import BrushfireField from "@brushfire/ui/dist/Elements/Form/BrushfireField";
import { putGroup, postResendGroupSignatures } from "../../../data/api";
import useWidgetHistory from "../../../hooks/useWidgetHistory";
import { useDispatch } from "react-redux";
import { AppFormContext } from "../../../App";
var MyGroup = function (_a) {
    var _b;
    var eventData = _a.eventData, group = _a.group, path = _a.path, kiosk = _a.kiosk, setCurrentGroup = _a.setCurrentGroup, attendeeTypeData = _a.attendeeTypeData, setSuccessMessage = _a.setSuccessMessage;
    var _c = __read(useState(false), 2), signaturesSending = _c[0], setSignaturesSending = _c[1];
    var _d = __read(useState(false), 2), signaturesSent = _d[0], setSignaturesSent = _d[1];
    var _e = __read(useState(false), 2), signaturesError = _e[0], setSignaturesError = _e[1];
    var intl = useIntl();
    var history = useWidgetHistory();
    var dispatch = useDispatch();
    var formikContext = useContext(AppFormContext).formikContext;
    if (!group || !attendeeTypeData) {
        return (_jsx(WidgetSticky, __assign({ className: "sticky-form", bottomOffset: 75, topOffset: 10, active: true }, { children: _jsxs(Row, { children: [_jsx(Col, __assign({ xs: 12 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) })), _jsx(Col, __assign({ xs: 12 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) }))] }) })));
    }
    var fieldViews = convertToFieldViews(group.fields);
    var initialValues = {
        fields: getInitialFieldValues({}, fieldViews, eventData),
        joinCode: group.joinCode,
        joinLink: "https://".concat(process.env.REACT_APP_DOMAIN).concat((eventData.verbiage === "Tickets"
            ? Constants.Routes.tickets
            : Constants.Routes.register)
            .replace(":clientKey", eventData.clientKey)
            .replace(":urlKey", eventData.urlKey)
            .replace(":eventNumber", eventData.eventNumber.toString()), "?group=").concat(group.id),
        name: group.name,
        email: group.email,
        attendeeTypeId: group.attendeeTypeId,
    };
    var fieldShape = getDynamicFieldValidation(fieldViews);
    var formSchema = Yup.object().shape({
        fields: Yup.object().shape(fieldShape),
        name: Yup.string().required("Group Name is required"),
        email: Yup.string()
            .email()
            .required("Email is required"),
        attendeeTypeId: Yup.string().required("".concat("Your group's most common ".concat(eventData.verbiage === "Tickets" ? "ticket" : "registration", " type"), " is required")),
        joinCode: Yup.string().required("Passcode to join group is required"),
    });
    var getRemoteValidateLocal = function (fieldId, value, setResponse) {
        return getRemoteValidateRes(fieldId, value, setResponse, eventData.eventNumber);
    };
    var getRemoteFetchValuesLocal = function (fieldId, value, setRemoteData) {
        return getRemoteFetchValues(fieldId, value, setRemoteData, eventData.eventNumber);
    };
    var onSubmit = function (values, formikHelpers) {
        var _a;
        var cleanedValues = Object.assign({}, values.fields);
        setSuccessMessage(undefined);
        (_a = Object.keys(cleanedValues)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
            var _a, _b, _c, _d;
            if (key === "isGift" || key === "recipientEmail" || key === "isPreRegistered" || key === "copyToAll") {
                delete cleanedValues[key];
            }
            else {
                if (Array.isArray(cleanedValues[key])) {
                    cleanedValues[key] = cleanedValues[key].filter(function (x) { return !!x; });
                    if (cleanedValues[key].some(function (x) { return !!x.price; })) {
                        var v = intl.formatNumberToParts(1000.0, {
                            style: "currency",
                            currency: (_a = eventData.currency) !== null && _a !== void 0 ? _a : "USD",
                        });
                        var symbol_1 = ((_b = v.find(function (x) { return x.type === "currency"; })) === null || _b === void 0 ? void 0 : _b.value) || "$";
                        var isCommaDecimal_1 = ((_c = v.find(function (x) { return x.type === "decimal"; })) === null || _c === void 0 ? void 0 : _c.value) === ",";
                        (_d = cleanedValues[key]) === null || _d === void 0 ? void 0 : _d.forEach(function (opt) {
                            var _a, _b;
                            if (isNaN(opt.price)) {
                                opt.price = opt.price
                                    ? opt.price === ""
                                        ? 0
                                        : isCommaDecimal_1
                                            ? parseFloat(((_a = opt.price) === null || _a === void 0 ? void 0 : _a.replace(/\s+/g, "").replace(",", ".").replace(symbol_1 || "$", "")) || "0.00")
                                            : parseFloat(((_b = opt.price) === null || _b === void 0 ? void 0 : _b.replace(/\s+/g, "").replace(symbol_1 || "$", "")) || "0.00")
                                    : 0;
                            }
                        });
                    }
                }
            }
        });
        var otherValues = Object.assign({}, values);
        delete otherValues.fields;
        var payload = __assign(__assign({}, otherValues), { fields: Object.keys(cleanedValues).map(function (key) { return ({ id: key, value: cleanedValues[key] }); }) });
        putGroup(group.id, payload)
            .then(function (_a) {
            var data = _a.data;
            setCurrentGroup(data);
            setSuccessMessage("Group Saved");
            formikHelpers.resetForm({ values: values });
        })
            .catch(function (err) {
            handleErrors(err, dispatch, formikContext);
        })
            .finally(function () {
            formikHelpers.setSubmitting(false);
        });
    };
    var groupOptions = (eventData.isGroupCentric
        ? attendeeTypeData !== null && attendeeTypeData !== void 0 ? attendeeTypeData : []
        : (_b = attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData.filter(function (a) { return a.isGroup; })) !== null && _b !== void 0 ? _b : [])
        .filter(function (type) { return type.isAvailable || group.attendeeTypeId === type.id; })
        .map(function (type) {
        var _a;
        return ({
            label: "".concat(type.name).concat(type.quantityRequirements && type.quantityRequirements !== "" ? " (".concat(type.quantityRequirements, ")") : "", " - ").concat(intl.formatNumber((_a = type.displayAmount) !== null && _a !== void 0 ? _a : 0, {
                currency: eventData.currency,
                style: "currency",
            })).concat(type.priceDescription ? " (".concat(type.priceDescription, ")") : ""),
            value: type.id,
        });
    });
    if (!attendeeTypeData.find(function (a) { return a.id === group.attendeeTypeId; })) {
        groupOptions.unshift({
            label: "".concat(group.typeName),
            value: group.attendeeTypeId,
        });
    }
    var showActions = group.attendees.some(function (a) { return a.status !== "Cancelled"; });
    return (_jsx(Form, __assign({ initialValues: initialValues, validationSchema: formSchema, onSubmit: onSubmit, formikBagProps: {
            submitButtonLabel: "Save",
        }, autoComplete: kiosk ? "new-off" : "on", useUnsavedPrompt: false }, { children: function (_a) {
            var formikContext = _a.formikContext;
            return (_jsxs(Row, __assign({ className: "flex-column-reverse flex-md-row" }, { children: [_jsx(Col, __assign({ md: showActions ? 9 : 12 }, { children: _jsx(WidgetFieldset, { children: _jsxs("div", __assign({ className: "pos-relative" }, { children: [_jsx(FormikContextListener, { currentPath: path, path: Constants.Routes.myGroup, formikContext: formikContext, active: true, initialValues: initialValues, focusDelay: 500 }), _jsx("div", { children: _jsxs(Row, { children: [_jsxs(Col, __assign({ sm: "12" }, { children: [_jsx(Form.Field, { name: "name", id: "name", label: "Group Name", autoComplete: !kiosk, className: "field m-top-0" }), _jsx(Form.Field, { label: "Your group's most common ".concat(eventData.verbiage === "Tickets" ? "ticket" : "registration", " type"), component: Form.Input.Select, id: "attendeeTypeId", name: "attendeeTypeId", data: groupOptions, autoComplete: "off", isSearchable: false }), _jsx(Form.Field, { name: "email", id: "email", label: "Email", type: "email", autoComplete: !kiosk }), _jsx(Form.Field, { name: "joinCode", id: "joinCode", label: "Passcode to join group", autoComplete: !kiosk, copyable: true }), _jsx(Form.Field, { name: "joinLink", id: "joinLink", label: "Link to join group", autoComplete: !kiosk, isFieldRequired: true, disabled: true, copyable: true })] })), !!fieldViews.length && (_jsx(Col, __assign({ sm: "12" }, { children: fieldViews.map(function (field, index) {
                                                        var visible = isVisible(field, formikContext.values.fields, fieldViews);
                                                        if (visible) {
                                                            return (_jsx(BrushfireField, { id: "".concat(field.id), name: "".concat(field.id), fieldItem: field, currency: eventData.currency, remoteValidate: getRemoteValidateLocal, remoteFetch: getRemoteFetchValuesLocal, autoComplete: !kiosk, prefix: "fields.", defaultCountry: getDefaultCountry(eventData), intl: intl }, field.id || index.toString()));
                                                        }
                                                    }) })))] }) })] })) }) })), showActions && (_jsxs(Col, __assign({ md: "3", className: "m-bottom-well" }, { children: [_jsx("div", __assign({ className: "d-flex justify-space-between align-center" }, { children: _jsx("h6", __assign({ className: "semi-bold" }, { children: "Actions" })) })), _jsxs(Well, __assign({ className: "well-outline well-sidebar", contentClassName: "d-flex flex-column details-gap" }, { children: [_jsxs("a", __assign({ href: "https://".concat(process.env.REACT_APP_DOMAIN).concat(Constants.Routes.portalGroupTicket
                                            .replace(":clientKey", eventData.clientKey)
                                            .replace(":urlKey", eventData.urlKey)
                                            .replace(":groupId", group.id)
                                            .replace(":eventNumber", eventData.eventNumber.toString())), tabIndex: 0, className: "unstyled-link details-sidebar-item", target: "_blank", rel: "noopener noreferrer" }, { children: [_jsx(Icon, { classes: "fa-fw", icon: "ticket" }), _jsx("span", { children: "View Ticket" })] })), group.attendeeCount > 0 && (_jsxs("a", __assign({ href: "https://".concat(process.env.REACT_APP_DOMAIN).concat(Constants.Routes.myGroupAttendees
                                            .replace(":clientKey", eventData.clientKey)
                                            .replace(":urlKey", eventData.urlKey)
                                            .replace(":groupId", group.id)
                                            .replace(":eventNumber", eventData.eventNumber.toString())
                                            .replace(Constants.Regex.guid, "")), tabIndex: 0, className: "unstyled-link details-sidebar-item" }, { children: [_jsx(Icon, { classes: "fa-fw", icon: "user" }), _jsx("span", { children: "Manage Attendees" })] }))), group.hasPendingSignatures && (_jsx("a", __assign({ href: "#", tabIndex: 0, className: "unstyled-link details-sidebar-item ".concat(signaturesSending ? "disabled" : ""), rel: "noopener noreferrer", onClick: function (evt) {
                                            if (!signaturesSending) {
                                                evt.stopPropagation();
                                                evt.preventDefault();
                                                setSignaturesSending(true);
                                                postResendGroupSignatures(group.id)
                                                    .then(function () {
                                                    setSignaturesSent(true);
                                                    setTimeout(function () {
                                                        setSignaturesSent(false);
                                                    }, 5000);
                                                })
                                                    .catch(function () {
                                                    setSignaturesError(true);
                                                    setTimeout(function () {
                                                        setSignaturesError(false);
                                                    }, 5000);
                                                })
                                                    .finally(function () {
                                                    setSignaturesSending(false);
                                                });
                                            }
                                        } }, { children: signaturesSent ? (_jsxs(_Fragment, { children: [_jsx(Icon, { icon: "check", classes: "m-right fa-fw" }), _jsx("span", { children: "Signatures Sent!" })] })) : (_jsx(_Fragment, { children: signaturesError ? (_jsxs(_Fragment, { children: [_jsx(Icon, { icon: "triangle-exclamation", classes: "m-right fa-fw" }), _jsx("span", { children: "Something went wrong while resending your signature" })] })) : (_jsxs(_Fragment, { children: [signaturesSending ? (_jsx(Icon, { icon: "spinner-third", classes: "fa-spin m-right fa-fw" })) : (_jsx(Icon, { icon: "pen-field", classes: "m-right fa-fw" })), _jsx("span", { children: "Resend Signatures" })] })) })) })))] }))] })))] })));
        } })));
};
export default MyGroup;
